import i18n from "i18next";
import { initReactI18next } from "react-i18next";

/* ----------------------------------------
   ABOUT
----------------------------------------- */
import aboutEN from "./locales/en/about.json";
import aboutES from "./locales/es/about.json";
import aboutIT from "./locales/it/about.json";
import aboutJA from "./locales/ja/about.json";
import aboutDE from "./locales/de/about.json";
import aboutFR from "./locales/fr/about.json";

/* ----------------------------------------
   ACCOMMODATIONS
----------------------------------------- */
import accomodationsEN from "./locales/en/accomodations.json";
import accomodationsES from "./locales/es/accomodations.json";
import accomodationsIT from "./locales/it/accomodations.json";
import accomodationsJA from "./locales/ja/accomodations.json";
import accomodationsDE from "./locales/de/accomodations.json";
import accomodationsFR from "./locales/fr/accomodations.json";

/* ----------------------------------------
   DESTINATIONS
----------------------------------------- */
import destinationsEN from "./locales/en/destinations.json";
import destinationsES from "./locales/es/destinations.json";
import destinationsIT from "./locales/it/destinations.json";
import destinationsJA from "./locales/ja/destinations.json";
import destinationsDE from "./locales/de/destinations.json";
import destinationsFR from "./locales/fr/destinations.json";

/* ----------------------------------------
   FLY SAFARI
----------------------------------------- */
import flysafariEN from "./locales/en/flysafari.json";
import flysafariES from "./locales/es/flysafari.json";
import flysafariIT from "./locales/it/flysafari.json";
import flysafariJA from "./locales/ja/flysafari.json";
import flysafariDE from "./locales/de/flysafari.json";
import flysafariFR from "./locales/fr/flysafari.json";

/* ----------------------------------------
   HOME
----------------------------------------- */
import homeEN from "./locales/en/home.json";
import homeES from "./locales/es/home.json";
import homeIT from "./locales/it/home.json";
import homeJA from "./locales/ja/home.json";
import homeDE from "./locales/de/home.json";
import homeFR from "./locales/fr/home.json";

/* ----------------------------------------
   OSILIGI
----------------------------------------- */
import osiligiEN from "./locales/en/osiligi.json";
import osiligiES from "./locales/es/osiligi.json";
import osiligiIT from "./locales/it/osiligi.json";
import osiligiJA from "./locales/ja/osiligi.json";
import osiligiDE from "./locales/de/osiligi.json";
import osiligiFR from "./locales/fr/osiligi.json";

/* ----------------------------------------
   TOURS
----------------------------------------- */
import toursEN from "./locales/en/tours.json";
import toursES from "./locales/es/tours.json";
import toursIT from "./locales/it/tours.json";
import toursJA from "./locales/ja/tours.json";
import toursDE from "./locales/de/tours.json";
import toursFR from "./locales/fr/tours.json";

/* ----------------------------------------
   NATIONAL PARKS
----------------------------------------- */
import amboseliEN from "./locales/en/amboseli.json";
import amboseliES from "./locales/es/amboseli.json";
import amboseliIT from "./locales/it/amboseli.json";
import amboseliJA from "./locales/ja/amboseli.json";
import amboseliDE from "./locales/de/amboseli.json";
import amboseliFR from "./locales/fr/amboseli.json";

import naivashaEN from "./locales/en/naivasha.json";
import naivashaES from "./locales/es/naivasha.json";
import naivashaIT from "./locales/it/naivasha.json";
import naivashaJA from "./locales/ja/naivasha.json";
import naivashaDE from "./locales/de/naivasha.json";
import naivashaFR from "./locales/fr/naivasha.json";

import tsavoEN from "./locales/en/tsavo.json";
import tsavoES from "./locales/es/tsavo.json";
import tsavoIT from "./locales/it/tsavo.json";
import tsavoJA from "./locales/ja/tsavo.json";
import tsavoDE from "./locales/de/tsavo.json";
import tsavoFR from "./locales/fr/tsavo.json";

import samburuEN from "./locales/en/samburu.json";
import samburuES from "./locales/es/samburu.json";
import samburuIT from "./locales/it/samburu.json";
import samburuJA from "./locales/ja/samburu.json";
import samburuDE from "./locales/de/samburu.json";
import samburuFR from "./locales/fr/samburu.json";

import olpejetaEN from "./locales/en/olpejeta.json";
import olpejetaES from "./locales/es/olpejeta.json";
import olpejetaIT from "./locales/it/olpejeta.json";
import olpejetaJA from "./locales/ja/olpejeta.json";
import olpejetaDE from "./locales/de/olpejeta.json";
import olpejetaFR from "./locales/fr/olpejeta.json";

import maraEN from "./locales/en/mara.json";
import maraES from "./locales/es/mara.json";
import maraIT from "./locales/it/mara.json";
import maraJA from "./locales/ja/mara.json";
import maraDE from "./locales/de/mara.json";      
import maraFR from "./locales/fr/mara.json";      

import nakuruEN from "./locales/en/nakuru.json";
import nakuruES from "./locales/es/nakuru.json";
import nakuruIT from "./locales/it/nakuru.json";
import nakuruJA from "./locales/ja/nakuru.json";
import nakuruDE from "./locales/de/nakuru.json";  
import nakuruFR from "./locales/fr/nakuru.json";  

/* ----------------------------------------
   SHELA
----------------------------------------- */
import shelaEN from "./locales/en/shela.json";
import shelaES from "./locales/es/shela.json";
import shelaIT from "./locales/it/shela.json";
import shelaJA from "./locales/ja/shela.json";
import shelaDE from "./locales/de/shela.json";
import shelaFR from "./locales/fr/shela.json";

/* ----------------------------------------
   PACKAGES
----------------------------------------- */
import packagefamilyEN from "./locales/en/packagefamily.json";
import packagefamilyES from "./locales/es/packagefamily.json";
import packagefamilyIT from "./locales/it/packagefamily.json";
import packagefamilyJA from "./locales/ja/packagefamily.json";
import packagefamilyDE from "./locales/de/packagefamily.json";
import packagefamilyFR from "./locales/fr/packagefamily.json";

import packagemaraEN from "./locales/en/packagemara.json";
import packagemaraES from "./locales/es/packagemara.json";
import packagemaraIT from "./locales/it/packagemara.json";
import packagemaraJA from "./locales/ja/packagemara.json";
import packagemaraDE from "./locales/de/packagemara.json";
import packagemaraFR from "./locales/fr/packagemara.json";

import packagenakuruEN from "./locales/en/packagenakuru.json";
import packagenakuruES from "./locales/es/packagenakuru.json";
import packagenakuruIT from "./locales/it/packagenakuru.json";
import packagenakuruJA from "./locales/ja/packagenakuru.json";
import packagenakuruDE from "./locales/de/packagenakuru.json";
import packagenakuruFR from "./locales/fr/packagenakuru.json";

import packageosiligiEN from "./locales/en/packageosiligi.json";
import packageosiligiES from "./locales/es/packageosiligi.json";
import packageosiligiIT from "./locales/it/packageosiligi.json";
import packageosiligiJA from "./locales/ja/packageosiligi.json";
import packageosiligiDE from "./locales/de/packageosiligi.json";
import packageosiligiFR from "./locales/fr/packageosiligi.json";

/* ----------------------------------------
   NEW 
----------------------------------------- */
import amboselitsavopackEN from "./locales/en/amboselitsavopack.json";
import amboselitsavopackES from "./locales/es/amboselitsavopack.json";
import amboselitsavopackIT from "./locales/it/amboselitsavopack.json";
import amboselitsavopackJA from "./locales/ja/amboselitsavopack.json";
import amboselitsavopackDE from "./locales/de/amboselitsavopack.json";
import amboselitsavopackFR from "./locales/fr/amboselitsavopack.json";

import olpejetasamburupackEN from "./locales/en/olpejetasamburupack.json";
import olpejetasamburupackES from "./locales/es/olpejetasamburupack.json";
import olpejetasamburupackIT from "./locales/it/olpejetasamburupack.json";
import olpejetasamburupackJA from "./locales/ja/olpejetasamburupack.json";
import olpejetasamburupackDE from "./locales/de/olpejetasamburupack.json";
import olpejetasamburupackFR from "./locales/fr/olpejetasamburupack.json";

import kenyaclassicEN from "./locales/en/kenyaclassic.json";
import kenyaclassicES from "./locales/es/kenyaclassic.json";
import kenyaclassicIT from "./locales/it/kenyaclassic.json";
import kenyaclassicJA from "./locales/ja/kenyaclassic.json";
import kenyaclassicDE from "./locales/de/kenyaclassic.json";
import kenyaclassicFR from "./locales/fr/kenyaclassic.json";

import serengetimaraEN from "./locales/en/serengetimara.json";
import serengetimaraES from "./locales/es/serengetimara.json";
import serengetimaraIT from "./locales/it/serengetimara.json";
import serengetimaraJA from "./locales/ja/serengetimara.json";
import serengetimaraDE from "./locales/de/serengetimara.json";
import serengetimaraFR from "./locales/fr/serengetimara.json";

/* ----------------------------------------
   NAVBAR
----------------------------------------- */
import navbarEN from "./locales/en/navbar.json";
import navbarES from "./locales/es/navbar.json";
import navbarIT from "./locales/it/navbar.json";
import navbarJA from "./locales/ja/navbar.json";
import navbarDE from "./locales/de/navbar.json";
import navbarFR from "./locales/fr/navbar.json";


/* ----------------------------------------
   RESOURCES
----------------------------------------- */
const resources = {
  en: {
    about: aboutEN,
    accomodations: accomodationsEN,
    destinations: destinationsEN,
    flysafari: flysafariEN,
    home: homeEN,
    osiligi: osiligiEN,
    tours: toursEN,
    amboseli: amboseliEN,
    naivasha: naivashaEN,
    tsavo: tsavoEN,
    samburu: samburuEN,
    olpejeta: olpejetaEN,
    mara: maraEN,
    nakuru: nakuruEN,
    shela: shelaEN,
    packagefamily: packagefamilyEN,
    packagemara: packagemaraEN,
    packagenakuru: packagenakuruEN,
    packageosiligi: packageosiligiEN,
    amboselitsavopack: amboselitsavopackEN,
    olpejetasamburupack: olpejetasamburupackEN,
    kenyaclassic: kenyaclassicEN,
    serengetimara: serengetimaraEN,
    navbar: navbarEN
  },

  es: {
    about: aboutES,
    accomodations: accomodationsES,
    destinations: destinationsES,
    flysafari: flysafariES,
    home: homeES,
    osiligi: osiligiES,
    tours: toursES,
    amboseli: amboseliES,
    naivasha: naivashaES,
    tsavo: tsavoES,
    samburu: samburuES,
    olpejeta: olpejetaES,
    mara: maraES,
    nakuru: nakuruES,
    shela: shelaES,
    packagefamily: packagefamilyES,
    packagemara: packagemaraES,
    packagenakuru: packagenakuruES,
    packageosiligi: packageosiligiES,
    amboselitsavopack: amboselitsavopackES,
    olpejetasamburupack: olpejetasamburupackES,
    kenyaclassic: kenyaclassicES,
    serengetimara: serengetimaraES,
    navbar: navbarES
  },

  it: {
    about: aboutIT,
    accomodations: accomodationsIT,
    destinations: destinationsIT,
    flysafari: flysafariIT,
    home: homeIT,
    osiligi: osiligiIT,
    tours: toursIT,
    amboseli: amboseliIT,
    naivasha: naivashaIT,
    tsavo: tsavoIT,
    samburu: samburuIT,
    olpejeta: olpejetaIT,
    mara: maraIT,
    nakuru: nakuruIT,
    shela: shelaIT,
    packagefamily: packagefamilyIT,
    packagemara: packagemaraIT,
    packagenakuru: packagenakuruIT,
    packageosiligi: packageosiligiIT,
    amboselitsavopack: amboselitsavopackIT,
    olpejetasamburupack: olpejetasamburupackIT,
    kenyaclassic: kenyaclassicIT,
    serengetimara: serengetimaraIT,
    navbar: navbarIT
  },

  ja: {
    about: aboutJA,
    accomodations: accomodationsJA,
    destinations: destinationsJA,
    flysafari: flysafariJA,
    home: homeJA,
    osiligi: osiligiJA,
    tours: toursJA,
    amboseli: amboseliJA,
    naivasha: naivashaJA,
    tsavo: tsavoJA,
    samburu: samburuJA,
    olpejeta: olpejetaJA,
    mara: maraJA,
    nakuru: nakuruJA,
    shela: shelaJA,
    packagefamily: packagefamilyJA,
    packagemara: packagemaraJA,
    packagenakuru: packagenakuruJA,
    packageosiligi: packageosiligiJA,
    amboselitsavopack: amboselitsavopackJA,
    olpejetasamburupack: olpejetasamburupackJA,
    kenyaclassic: kenyaclassicJA,
    serengetimara: serengetimaraJA,
    navbar: navbarJA
  },

  de: {
    about: aboutDE,
    accomodations: accomodationsDE,
    destinations: destinationsDE,
    flysafari: flysafariDE,
    home: homeDE,
    osiligi: osiligiDE,
    tours: toursDE,
    amboseli: amboseliDE,
    naivasha: naivashaDE,
    tsavo: tsavoDE,
    samburu: samburuDE,
    olpejeta: olpejetaDE,
    mara: maraDE,
    nakuru: nakuruDE,
    shela: shelaDE,
    packagefamily: packagefamilyDE,
    packagemara: packagemaraDE,
    packagenakuru: packagenakuruDE,
    packageosiligi: packageosiligiDE,
    amboselitsavopack: amboselitsavopackDE,
    olpejetasamburupack: olpejetasamburupackDE,
    kenyaclassic: kenyaclassicDE,
    serengetimara: serengetimaraDE,
    navbar: navbarDE
  },

  fr: {
    about: aboutFR,
    accomodations: accomodationsFR,
    destinations: destinationsFR,
    flysafari: flysafariFR,
    home: homeFR,
    osiligi: osiligiFR,
    tours: toursFR,
    amboseli: amboseliFR,
    naivasha: naivashaFR,
    tsavo: tsavoFR,
    samburu: samburuFR,
    olpejeta: olpejetaFR,
    mara: maraFR,
    nakuru: nakuruFR,
    shela: shelaFR,
    packagefamily: packagefamilyFR,
    packagemara: packagemaraFR,
    packagenakuru: packagenakuruFR,
    packageosiligi: packageosiligiFR,
    amboselitsavopack: amboselitsavopackFR,
    olpejetasamburupack: olpejetasamburupackFR,
    kenyaclassic: kenyaclassicFR,
    serengetimara: serengetimaraFR,
    navbar: navbarFR
  }
};

/* ----------------------------------------
   INIT
----------------------------------------- */


i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    ns: [
      'about', 'accomodations', 'destinations', 'flysafari', 'home', 
      'osiligi', 'tours', 'amboseli', 'naivasha', 'tsavo', 'samburu',
      'olpejeta', 'mara', 'nakuru', 'shela', 'packagefamily', 'packagemara',
      'packagenakuru', 'packageosiligi', 'amboselitsavopack', 'olpejetasamburupack',
      'kenyaclassic', 'serengetimara', 'navbar'
    ],
    
  
  });

export default i18n;
